import { CollectorBillScenario } from './Collector/Billing-Scenario/billingScenario.models';

export class Collector {
    abbr: string;
    address: string;
    addressID: number;
    collectorBillScenarios: CollectorBillScenario[];
    collector: Weissman.Model.Collectors.Collector;
    collectorID: number;
    efAction: string;
    electronicPaymentRequired: boolean;
    enabled: boolean;
    hasComments: boolean;
    isCompanyCollector: boolean;
    municipalityID: number;
    name: string;
    stateID: number;
    stubTypeRequired: number;
    ptxId: string;
}
